import { render, staticRenderFns } from "./referrals-accured-written-off-cell.vue?vue&type=template&id=a33ee9fe&scoped=true&"
import script from "./referrals-accured-written-off-cell.vue?vue&type=script&lang=js&"
export * from "./referrals-accured-written-off-cell.vue?vue&type=script&lang=js&"
import style0 from "./referrals-accured-written-off-cell.vue?vue&type=style&index=0&id=a33ee9fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33ee9fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a33ee9fe')) {
      api.createRecord('a33ee9fe', component.options)
    } else {
      api.reload('a33ee9fe', component.options)
    }
    module.hot.accept("./referrals-accured-written-off-cell.vue?vue&type=template&id=a33ee9fe&scoped=true&", function () {
      api.rerender('a33ee9fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/additions/data-table/referrals-accured-written-off-cell.vue"
export default component.exports